import { render } from "./Collection.vue?vue&type=template&id=5f380176"
const script = {}

import "./Collection.vue?vue&type=style&index=0&id=5f380176&lang=css"

import exportComponent from "/Users/isamu/ss/web3/laidbacklu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__